import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-table/dist/bootstrap-table.css";
import "antd/dist/antd.css";

ReactDOM.render(<App />, document.getElementById("root"));
